import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {ResourcePlanningFilterType} from 'app/blocks/model/enums/resource-planning-filter/resource-planning-filter-type.enum';
import {ResourcePlanningFilterCriteria} from 'app/blocks/model/resource-planning-filter/resource-planning-filter-criteria.model';
import {User} from 'app/core/user/user.model';

export interface IResourcePlanningFilter extends IBaseEntity {
    id: number;
    name: string;
    filterType: ResourcePlanningFilterType;
    filterCriteria: ResourcePlanningFilterCriteria[];
    assignedUsers: User[];
}

export class ResourcePlanningFilter extends BaseEntity implements IResourcePlanningFilter {
    constructor(obj?) {
        super();

        if (obj) {
            this.id = obj.id;
            this.name = obj.name;
            this.filterType = obj.filterType;
            this.filterCriteria = obj.filterCriteria || [];
            this.assignedUsers = obj.assignedUsers || [];
            return;
        } else {
            this.filterCriteria = [];
            this.assignedUsers = [];
        }
    }

    id: number;
    name: string;
    readonly filterType: ResourcePlanningFilterType;
    filterCriteria: ResourcePlanningFilterCriteria[];
    assignedUsers: User[];

    clone(): IBaseEntity {
        return new ResourcePlanningFilter(this);
    }
}
